import { Component, OnInit } from '@angular/core';
import { ApplicationState, getProducts } from '../../store/reducers';
import { OnDestroyHookDirective } from '../../shared/hooks';
import { Store } from '@ngrx/store';
import { TranslationService } from '@proximus/ng-common';
import { Product } from '@dch/products-business-logic';

@Component({
  selector: 'mprd-norton-family',
  templateUrl: './norton-family.component.html',
  styleUrls: ['./norton-family.component.css'],
})
export class NortonFamilyComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  showComponent = false;

  constructor(
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.store.select(getProducts).subscribe((products) => {
        if (products && products.length > 0) {
          this.showComponent = this.hasNorton5Product(products);
        }
      }),
    );
  }

  private hasNorton5Product(products: Array<Product>) {
    const norton5MpcUuid = this.translationService.getTranslatedValueFor(
      'norton.subscription.norton5MpcUuid',
    );
    return (
      products
        .filter((product) => norton5MpcUuid === product.groupMpcUuid)
        .map((product) => product.accessNumber).length > 0
    );
  }
}
